import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type DeleteUserFeatureMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
  featureId: Types.Scalars['bigint']['input'];
}>;


export type DeleteUserFeatureMutation = { __typename?: 'mutation_root', delete_usertofeatures?: { __typename?: 'usertofeatures_mutation_response', affected_rows: number } | null };


export const DeleteUserFeatureDocument = gql`
    mutation DeleteUserFeature($userId: bigint!, $featureId: bigint!) {
  delete_usertofeatures(
    where: {user_id: {_eq: $userId}, feature_id: {_eq: $featureId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteUserFeatureMutationFn = Apollo.MutationFunction<DeleteUserFeatureMutation, DeleteUserFeatureMutationVariables>;

/**
 * __useDeleteUserFeatureMutation__
 *
 * To run a mutation, you first call `useDeleteUserFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFeatureMutation, { data, loading, error }] = useDeleteUserFeatureMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useDeleteUserFeatureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFeatureMutation, DeleteUserFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFeatureMutation, DeleteUserFeatureMutationVariables>(DeleteUserFeatureDocument, options);
      }
export type DeleteUserFeatureMutationHookResult = ReturnType<typeof useDeleteUserFeatureMutation>;
export type DeleteUserFeatureMutationResult = Apollo.MutationResult<DeleteUserFeatureMutation>;
export type DeleteUserFeatureMutationOptions = Apollo.BaseMutationOptions<DeleteUserFeatureMutation, DeleteUserFeatureMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/deleteUserFeature.mutation.gql}
 */
export async function deleteUserFeature(
  variables: DeleteUserFeatureMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteUserFeatureMutation['delete_usertofeatures']>
export async function deleteUserFeature(
  variables: DeleteUserFeatureMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteUserFeatureMutation>
export async function deleteUserFeature(
  variables: DeleteUserFeatureMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteUserFeatureMutation['delete_usertofeatures'] | DeleteUserFeatureMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteUserFeatureMutation>(
    DeleteUserFeatureDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_usertofeatures
}